module.exports = __webpack_public_path__ + "img/solution_2.9539811a.png";